import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=61e794fc&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=61e794fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e794fc",
  null
  
)

export default component.exports